import {actionTypes, scheduleOperationTypes} from "../types";
import {ModalContainerTGO} from "../Modal/ModalContainerTGO";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'

import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import {isCanvasBlank, saveTGOtoDB} from "../functions";
import {ModalContainerAudioRecord} from "../Modal/ModalContainerAudioRecord";
import {modalContainerWarningAudioRecord} from "../Modal/ModalContainerWarningAudioRecord";
import {ModalWindowSignatureLS} from "../Modal/ModalWindowSignatureLS";
import SignaturePad from "signature_pad";
import { TIME_FORMAT } from '@/utils.js'
import {appNotification} from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { cache } from '@/components/Cache.js';
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';
import { flightMenuBlock } from '@/Block/FlightMenuBlock.js';

export const flightSchedule = {
    error: '',
    operationsList: [],
    schedules: [],
    currentSchedule: 0,
    currentTask: null,
    audioComment: [],
    isLoading: false, 
    board: null,

    response: null,
    audioComment: [],
    time: new Date().toLocaleTimeString(),
    commentInFocus: false,

    hasError: function () {
        return !!this.error;
    },

    get currentList () {
        return this.operationsList[this.currentSchedule];
    },

    currentOperation: function (key) {
        return this.currentList[key];
    },

    setCurrentOperation: function (key, value) {
        this.currentList[key] = value;
    },

    init: function (ping) {
        this.isLoading = true;
        // Проверка на активность ввода в поле комментария
        let comment_not_in_focus = true;
        const elements = document.getElementsByName("comment");
        for (var i = 0; i < elements.length; i++) {
            if (elements[i] === document.activeElement) {
                comment_not_in_focus = false;
            }
        }

         if (!comment_not_in_focus) {
            // Если комментарий в фокусе, не обновляем, но возвращаем Promise
            this.isLoading = false;
            return Promise.resolve({ skipUpdate: true });
        }

        return m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/schedule'
        }).then(function (response) {
            this.isLoading = false;
            server.setOnline();
            
            if (response.currentTask === null) {
                m.route('/');
                return { redirect: true };
            }

            flightSchedule.response = response;

            flightSchedule.operationsList = response.operations.list;
            flightSchedule.schedules = response.operations.schedules;
            flightSchedule.isSigned = response.operations.isSigned;
            flightSchedule.currentSchedule = response.operations.currentSchedule;
            

            flightSchedule.board = response.board;

            if(!flightSchedule.board.hasOwnProperty("buses")) {
                flightSchedule.board.buses = response.board.buses;
            }

            flightSchedule.currentTask = response.currentTask;
            appNotification.list = response.notifications;
            storage.config = response.config;
            flightSchedule.audioComment = response.audioComment || [];
            flightSchedule.commentInFocus = false;

            if (ping) {
                server.initPing();
                appNotification.init();
            }

            loader.hide();

            //if(ping) {
            //FlightSchedule.audioComment = response.audioComment;
            localStorage.setItem("AudioRecords", JSON.stringify(response.audioComment));
                //let audioRecords = document.getElementById("audioRecords");
            //}
            /*if(audioRecords)
                audioRecords.innerHTML = "";*/

           return {
                success: true,
            };
        }.bind(this), 
        function (response) {
            if (!response) {
                this.isLoading = false;

                server.setOffline();
            }
            loader.hide();
            // Возвращаем объект с ошибкой
            return {
                success: false,
                error: response,
                offline: !response
            };
        }.bind(this)).catch(function(error) {
            this.isLoading = false;
            loader.hide();
            console.error('Ошибка при загрузке данных:', error);
            flightSchedule.error = error.message
                ? error.message 
                : 'Ошибка загрузки';

                state.error = 'Нет соединения с сервером';
            
            return {
                success: false,
                error: error,
                offline: true
            }
        }.bind(this));
    },

    changeSchedule: function (number) {
        flightSchedule.currentSchedule = number;
    },

    refresh: function (operationIndex) {
        flightSchedule.currentList.forEach(function (obj, i) {
            if (operationIndex === i) {
                return 0;
            } else {
                obj.showDataInputs = false;
                obj.showCommentForm = false;
                obj.showCancelCommentForm = false;
                obj.showOperationValueForm = false;
            }

        })
    },

    initIntervalRefresh: function () {
        interval.make(function () {
            const number = flightSchedule.currentSchedule;
            flightSchedule.init(false).then(
                function (result) {
                    flightSchedule.changeSchedule(number);
                }
            );            
        }, 30000)
    },

    startTask: function () {
        flightSchedule.error = '';

        loader.show();

        m.request({
            method: 'PUT',
            url: '/api/task/' + flightSchedule.currentTask.taskId + '/start'
        }).then(function (response) {
            server.setOnline();
            loader.hide();

            flightSchedule.currentTask.factBeginDateTime = response.data;

            m.route('/task/' + taskId + '/schedule');
        }, function (response) {

            const data = {
                type: actionTypes.taskStart,
                taskId: flightSchedule.currentTask.taskId,
                ts: moment().format(TIME_FORMAT)
            };

            cache.push(data);

            if (response && response.message) {
                flightSchedule.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();

                flightSchedule.currentTask.factBeginDateTime = moment(data.ts, TIME_FORMAT).format('DD.MM.YYYY HH:mm');
            }
            loader.hide();
        });
    },

    finishTask: function (needConfirmation) {
        flightSchedule.error = '';

        if (needConfirmation) {
            if (!confirm('Вы уверены, что хотите выполнить действие?')) {
                return false;
            }
        }

        loader.show();

        m.request({
            method: 'PUT',
            url: '/api/task/' + flightSchedule.currentTask.taskId + '/finish'
        }).then(function () {
            server.setOnline();
            loader.hide();
            m.route('/');
        }, function (response) {
            //аудиокомментарий
            document.getElementById("mic_bg").parentNode.style = "display: none";
            const list = document.getElementsByClassName("fa-trash");
            for(let i = 0; i < list.length; i++) {
                list[i].parentNode.style = "display: none";
            }

            const data = {
                type: actionTypes.taskFinish,
                taskId: flightSchedule.currentTask.taskId,
                ts: moment().format(TIME_FORMAT)
            };

            cache.push(data);

            if (response && response.message) {
                flightSchedule.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();

                flightSchedule.currentTask.factFinishDateTime = moment(data.ts, TIME_FORMAT).format('DD.MM.YYYY HH:mm');
            }
            loader.hide();
        });
    },

    setOperationStartTime: function (key) {
        flightSchedule.error = '';

        loader.show();

        const operation = flightSchedule.currentOperation(key);

        const data = {
            operation: scheduleOperationTypes.startTime,
            serviceId: parseInt(operation.serviceId),
            scheduleNumber: flightSchedule.currentSchedule
        };

        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/schedule',
            data: data
        }).then(function (response) {
            response.operation.showDataInputs = operation.showDataInputs || false;
            response.operation.showCommentForm = operation.showCommentForm || false;
            response.operation.showCancelCommentForm = operation.showCancelCommentForm || false;

            flightSchedule.setCurrentOperation(key, response.operation);

            server.setOnline();
            loader.hide();
            m.redraw();
        }, function (response) {

            data.type = actionTypes.scheduleUpdate;
            data.taskId = m.route.param('taskId');
            data.ts = moment().format(TIME_FORMAT);
            cache.push(data);

            if (response && response.message) {
                flightSchedule.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();

                flightSchedule.currentOperation(key).factBeginTime = moment(data.ts, TIME_FORMAT).format('HH:mm');
            }
            loader.hide();
        }).catch(function () {
            window.location.reload();
        });
    },

    setOperationEndTime: function (key) {
        flightSchedule.error = '';

        loader.show();

        const operation = flightSchedule.currentOperation(key);

        const data = {
            operation: scheduleOperationTypes.endTime,
            serviceId: parseInt(operation.serviceId),
            scheduleNumber: flightSchedule.currentSchedule
        };

        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/schedule',
            data: data
        }).then(function (response) {

           if (operation) {
                response.operation.showDataInputs = operation.showDataInputs || false;
                response.operation.showCommentForm = operation.showCommentForm || false;
                response.operation.showCancelCommentForm = operation.showCancelCommentForm || false;
            }

            flightSchedule.setCurrentOperation(key, response.operation);

            server.setOnline();
            loader.hide();
            m.redraw();
        }, function (response) {

            data.type = actionTypes.scheduleUpdate;
            data.taskId = m.route.param('taskId');
            data.ts = moment().format(TIME_FORMAT);
            cache.push(data);

            if (response && response.message) {
                flightSchedule.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();

                flightSchedule.currentList[key].factFinishTime = moment(data.ts, TIME_FORMAT).format('HH:mm');
            }
            loader.hide();
        }).catch(function () {
            window.location.reload();
        });
    },

    setOperationCommonTime: function (key) {
        flightSchedule.error = '';

        loader.show();

        const operation = flightSchedule.currentOperation(key);

        const data = {
            operation: scheduleOperationTypes.commonTime,
            serviceId: parseInt(operation.serviceId),
            scheduleNumber: flightSchedule.currentSchedule
        };

        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/schedule',
            data: data
        }).then(function (response) {

            response.operation.showDataInputs = operation.showDataInputs || false;
            response.operation.showCommentForm = operation.showCommentForm || false;
            response.operation.showCancelCommentForm = operation.showCancelCommentForm || false;

            flightSchedule.setCurrentOperation(key, response.operation);

            server.setOnline();
            loader.hide();
        }, function (response) {

            data.type = actionTypes.scheduleUpdate;
            data.taskId = m.route.param('taskId');
            data.ts = moment().format(TIME_FORMAT);
            cache.push(data);

            if (response && response.message) {
                flightSchedule.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();

                flightSchedule.currentOperation[key].factBeginTime = moment(data.ts, TIME_FORMAT).format('HH:mm');
                flightSchedule.currentOperation[key].factFinishTime = moment(data.ts, TIME_FORMAT).format('HH:mm');
            }
            loader.hide();
        }).catch(function () {
            window.location.reload();
        });
    },

    saveOperationValue: function(key) {
        flightSchedule.error = '';

        loader.show();

        const operation = flightSchedule.currentList[key];

        const data = {
            operation: scheduleOperationTypes.saveOperationValue,
            serviceId: parseInt(operation.serviceId),
            operationValue: operation.operationValue,
            scheduleNumber: flightSchedule.currentSchedule
        };

        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/schedule',
            data: data
        }).then(function (response) {
            response.operation.showDataInputs = operation.showDataInputs || false;
            response.operation.showCommentForm = false; // Скрываем форму, после сохранения state.showCommentForm;
            /// TODO: Проверить нужен ли тут этот параметр
            response.operation.showOperationValueForm = false; // Скрываем форму ввода значения по операции


            flightSchedule.currentList[key] = response.operation;

            server.setOnline();
            loader.hide();
        }, function (response) {

            data.type = actionTypes.scheduleUpdate;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                flightSchedule.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        }).catch(function () {
            window.location.reload();
        });

    },

    saveOperationComment: function(key) {
        flightSchedule.error = '';

        loader.show();

        const operation = flightSchedule.currentList[key];

        const data = {
            operation: scheduleOperationTypes.comment,
            serviceId: parseInt(operation.serviceId),
            comment: operation.comment,
            scheduleNumber: flightSchedule.currentSchedule
        };

        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/schedule',
            data: data
        }).then(function (response) {

            response.operation.showDataInputs = operation.showDataInputs || false;
            response.operation.showCommentForm = false; // Скрываем форму, после сохранения state.showCommentForm;

            flightSchedule.currentList[key] = response.operation;

            server.setOnline();
            loader.hide();
        }, function (response) {

            data.type = actionTypes.scheduleUpdate;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                flightSchedule.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        }).catch(function () {
            window.location.reload();
        });
    },

    saveOperationCancelComment: function(key) {
        flightSchedule.error = '';

        loader.show();

        const operation = flightSchedule.currentList[key];

        const data = {
            operation: scheduleOperationTypes.cancelComment,
            serviceId: parseInt(operation.serviceId),
            comment: operation.comment,
            scheduleNumber: flightSchedule.currentSchedule
        };

        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/schedule',
            data: data
        }).then(function (response) {

            response.operation.showDataInputs = operation.showDataInputs || false;
            response.operation.showCancelCommentForm = false; // Скрываем форму, после сохранения state.showCommentForm;

            flightSchedule.currentList[key] = response.operation;

            server.setOnline();
            loader.hide();
        }, function (response) {

            data.type = actionTypes.scheduleUpdate;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                flightSchedule.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        }).catch(function () {
            window.location.reload();
        });
    },

    saveWorkComment: function() {
        flightSchedule.error = '';

        loader.show();

        const taskId = m.route.param('taskId');
        const taskComment = document.querySelector('.comment-' + taskId).value;

        const data = {
            operation: scheduleOperationTypes.taskComment,
            taskId: taskId,
            comment: taskComment,
            scheduleNumber: flightSchedule.currentSchedule
        };

        m.request({
            method: 'PUT',
            url: '/api/task/' + taskId + '/comment',
            data: data
        }).then(function () {
            document.querySelector('.comment-' + taskId).style.background="#bfffbf"; //После сохранения окрашеваем поле в зеленый
            server.setOnline();
            loader.hide();
        }, function (response) {

            data.type = actionTypes.taskComment;
            data.taskId = m.route.param('taskId');
            data.taskComment = taskComment;
            cache.push(data);

            if (response && response.message) {
                flightSchedule.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },

    saveCountBuses: function() {
        flightSchedule.error = '';

        loader.show();

        const countBuses = document.querySelector('.count-buses').value;
        const flightId = flightSchedule.currentTask.flightId;

        const data = {
            countBuses
        };

        m.request({
            method: 'PUT',
            url: '/api/flight/' + flightId + '/buses',
            data: data
        }).then(function () {
            document.querySelector('.count-buses').style.background="#bfffbf"; //После сохранения окрашеваем поле в зеленый
            server.setOnline();
            loader.hide();
        }, function (response) {
            if (response && response.message) {
                flightSchedule.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },

    getStatusLoadsheet: function (i, type) {
        loader.show()
        m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/getStatusLoadSheet'
        }).then(function (response) {
            if(response.code === 0 || response.code === 1) {
                ModalWindowSignatureLS.open(i, type, "ModalWindowSignatureLS")
            } else if (response.code === 2) {
                switch (type) {
                    case 1:
                        flightSchedule.setOperationStartTime(i);
                        break;
                    case 2:
                        flightSchedule.setOperationEndTime(i);
                        break;
                    case 3:
                        flightSchedule.setOperationCommonTime(i);
                        break;
                }
            }
            loader.hide();
            return response;
        }, function (response) {
            if (response && response.message) {
                flightSchedule.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    }
};

export const flightSchedulePage = {
    controller: function() {
        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();
        loader.show();

        // Состояние компонента находится в flightSchedule
        const state = flightSchedule;

        // Загружаем данные
        flightSchedule.init(true).then(function(result) {
            m.redraw(); // Перерисовываем компонент            
        }).catch(function(error) {
            console.error('Controller error:', error);
            state.isLoading = false;
            state.error = 'Критическая ошибка';
            m.redraw();
        });

        // Инициализируем обновление по таймеру
        setTimeout(function () {
            flightSchedule.initIntervalRefresh();
        }, 1500);

        return {
            state: state,
            topMenu: [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' },
            ]
        };
    },
    
    view: function(ctrl) {
        const state = flightSchedule;
        
        // Показываем лоадер только при первой загрузке
        if (state.isLoading && !state.currentTask) {
            return [
                m.component(HeaderMenuBlock, {
                    time: state.time,
                    menu: ctrl.topMenu
                }),
                m("div.text-center", {style: "padding: 50px"}, [
                    m("i.fa.fa-spinner.fa-spin.fa-3x"),
                    m("p", "Загрузка расписания...")
                ])
            ];
        }
        
        // Показываем ошибку только если нет данных
        if (state.hasError() && !state.currentTask) {
            return [
                m.component(HeaderMenuBlock, {
                    time: state.time,
                    menu: ctrl.topMenu
                }),
                m("div[style='margin-top:0px']", ''),
                m("div[style='padding:7px 15px']", [
                    m(".alert.alert-danger", state.error)
                ]),
                m("div.text-center", {style: "padding: 20px"}, 
                    m("button.btn.btn-primary", {
                        onclick: function() {
                            flightSchedule.init(true);                            
                        }
                    }, "Повторить попытку")
                )
            ];
        }
        
        // Если комментарий в фокусе, но уже есть данные - показываем старые данные
        if (state.commentInFocus && state.currentTask) {
            // Ничего не делаем, продолжаем показывать текущий интерфейс
        }
        
        // Если нет данных и комментарий не в фокусе
        if (!state.currentTask && !state.commentInFocus) {
            return [
                m.component(HeaderMenuBlock, {
                    time: state.time,
                    menu: ctrl.topMenu
                }),
                m("div[style='margin-top:0px']", ''),
                m("div[style='padding:7px 15px']", [
                    m(".alert.alert-info", "Нет данных для отображения")
                ])
            ];
        }
        
        // Основной рендеринг с данными
        // Используем данные из flightSchedule если state еще не обновился
        const currentTask = flightSchedule.currentTask;
        const currentList = flightSchedule.currentList;
        const currentConfig = storage.config;
        const currentAudioComment = flightSchedule.audioComment.length > 0 ? state.audioComment : 
                                  (localStorage.getItem("AudioRecords") ? JSON.parse(localStorage.getItem("AudioRecords")) : []);
        
        const CardSignature = currentConfig.CardSignature ?? false;
        const DenyCloseWorks = currentConfig.DenyCloseWorks ?? false;
        let allTGOReady;
        let showEndWorkButton;
        let showSignatureButton;

        if(currentList?.filter(x => (x.factBeginTime == null || x.factFinishTime == null) && !x.isCancelled).length === 0) {
            allTGOReady = true;
        } else {
            allTGOReady = false;
        }

        if(currentTask && currentTask.factBeginDateTime) {
            if(DenyCloseWorks && CardSignature) {
                if(allTGOReady) {
                    showEndWorkButton = true;
                    showSignatureButton = true;
                } else {
                    showEndWorkButton = false;
                    showSignatureButton = false;
                }
            } else if(!DenyCloseWorks && CardSignature) {
                showEndWorkButton = true;
                showSignatureButton = true;
            } else if(!DenyCloseWorks && !CardSignature) {
                showEndWorkButton = true;
                showSignatureButton = false;
            } else if(DenyCloseWorks && !CardSignature) {
                showSignatureButton = false;

                if(allTGOReady) {
                    showEndWorkButton = true;
                } else {
                    showEndWorkButton = false;
                }
            }
        } else {
            showEndWorkButton = false;
            showSignatureButton = false;
        }

        // Основной view
        return [
            m.component(HeaderMenuBlock, {
                time: state.time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", ''),
            m.component(flightMenuBlock, {
                board: state.board,
                menu: state.response?.menu || [],
                tasks: state.response?.tasks || [],
                currentTask: currentTask,
                schedules: state.schedules || [],
                tab: 'schedule'
            }),
            flightSchedule.error,
            currentTask ? m("div[style='padding:7px 15px']", [
                currentTask.factBeginDateTime ?
                    m(".text-center.alert.alert-info", "Дата начала работы: " + currentTask.factBeginDateTime) :
                    m("button.btn.btn-info.btn-block.btn-lg", {
                        onclick: function () {
                            flightSchedule.startTask();
                        }
                    }, "Начать работу (" + currentTask.planBeginTime + ")")
            ]) : null,
            
            // Комментарий сверху списка
            (currentConfig.work_comment_on_top && currentTask) ?
                m("div[style='padding:7px 15px']", [
                    m("div[style='padding:7px 15px']", [
                        m("b", "Комментарий к работе"),
                        m("div", [
                            m("div[style='width: 100%;display: inline-flex;flex-direction: row;']", [
                                m("textarea.form-control.comment-" + currentTask.taskId, {
                                    rows: 2,
                                    name: 'comment',
                                    placeholder: 'Введите комментарий',
                                    onchange: function (e) {
                                        currentTask.comment = e.target.value;
                                    }
                                }, currentTask.comment || ''),
                                m("button.btn", {
                                    onclick: function () {
                                        var permissionMic = false;
                                        if (!navigator.mediaDevices.enumerateDevices) {
                                            alert("enumerateDevices() not supported.");
                                        } else {
                                            navigator.mediaDevices
                                                .enumerateDevices()
                                                .then((devices) => {
                                                    for(let i = 0; i < devices.length; i++) {
                                                        if(devices[i].kind == "audioinput" && devices[i].deviceId != "") {
                                                            permissionMic = true;
                                                            break;
                                                        }
                                                    }
                                                    if(permissionMic) {
                                                        let timerId = localStorage.getItem("audioTimerId");
                                                        timerId !== 'underfined' ? timerId : 0;

                                                        if (!timerId) {
                                                            let event = new Event("startAudioRecord", {bubbles: false});
                                                            document.dispatchEvent(event);

                                                            let timerSec = 0;
                                                            let maxTime = currentConfig.LengthAudioRecord;
                                                            timerId = setInterval(function () {
                                                                timerSec++;
                                                                const minutes = Math.floor(timerSec / 60);
                                                                const seconds = timerSec - minutes * 60;
                                                                let formatted = [
                                                                    minutes.toString().padStart(2, '0'),
                                                                    seconds.toString().padStart(2, '0')
                                                                ].join(':');
                                                                document.getElementById("audioTimer").innerHTML = formatted;
                                                                if(timerSec == maxTime) {
                                                                    localStorage.setItem("lengthAudio", formatted);
                                                                    ModalContainerAudioRecord.close(true);
                                                                    let buttons = document.createElement("div");
                                                                    buttons.className = "col-12";
                                                                    let btn_ok = document.createElement("button");
                                                                    btn_ok.classList.add('btn', 'btn-warning', 'btn-md');
                                                                    btn_ok.innerText = "OK";
                                                                    btn_ok.onclick = modalContainerWarningAudioRecord.close;
                                                                    buttons.append(btn_ok);

                                                                    modalContainerWarningAudioRecord
                                                                        .open("Предупреждение",
                                                                            "Записан аудиокомментарий максимальной длительности",
                                                                            buttons);
                                                                }
                                                            }, 1000, timerSec, maxTime);
                                                            localStorage.setItem("audioTimerId", timerId);
                                                        }
                                                        ModalContainerAudioRecord.open();
                                                    }
                                                    else {
                                                        alert("Необходимо разрешить браузеру доступ к микрофону");
                                                    }
                                                })
                                                .catch((err) => {
                                                    alert(err.name + err.message);
                                                });
                                        }
                                    }
                                }, [
                                    m("div.record-button[id='mic_bg'][style='width:50px; height:50px']", [
                                        m("i.fa.fa-2x.fa-thin.fa-microphone[id='mic_icon']")
                                    ])
                                ]),
                            ]),
                            m("button.btn.btn-info.btn-block[type='text'][style='margin-top:3px']", {
                                onclick: function () {
                                    flightSchedule.saveWorkComment();
                                }
                            }, "Сохранить комментарий")
                        ]),
                        m("div[id='audioRecords'][style='margin-top: 15px']",[
                            currentAudioComment.map(function (im) {
                                return m("div[name='"+im.fileID+"'][style='margin-top:4px']", [
                                    m("audio[src=" + im.base64 + "]",
                                        {
                                            onended: function () {
                                                let button_play = this.parentNode.getElementsByTagName("button")[0];
                                                let i = button_play.getElementsByTagName("icon")[0];
                                                if (i.classList.contains("fa-pause")) {
                                                    this.pause();
                                                    i.classList.remove("fa-pause");
                                                    i.classList.add("fa-play");
                                                }
                                            }
                                        }),
                                    m("div.container[style='display: flex; justify-content: space-between;']", [
                                        m("div[style='display: flex; align-items: center;']", [im.fileName]),
                                        m("div", [
                                            m("button", {
                                                onclick: function () {
                                                    let i = this.getElementsByTagName("icon")[0];
                                                    if (i.classList.contains("fa-play")) {
                                                        let audio = this.parentNode.parentNode.parentNode.getElementsByTagName("audio")[0];
                                                        audio.play();
                                                        i.classList.remove("fa-play");
                                                        i.classList.add("fa-pause");
                                                    } else if (i.classList.contains("fa-pause")) {
                                                        let audio = this.parentNode.parentNode.parentNode.getElementsByTagName("audio")[0];
                                                        audio.pause();
                                                        i.classList.remove("fa-pause");
                                                        i.classList.add("fa-play");
                                                    }
                                                }
                                            }, [
                                                m("icon.fa.fa-play")
                                            ]),
                                            m("button[style='margin-left: 5px'][id='"+im.fileID+"']", {
                                                onclick: function (el) {
                                                    localStorage.setItem("selectID", el.currentTarget.id);
                                                    let buttons = document.createElement("div");
                                                    let btn_yes = document.createElement("button");
                                                    btn_yes.classList.add('col-6', 'btn', 'btn-warning', 'btn-md');
                                                    btn_yes.innerText = "Да";
                                                    btn_yes.onclick = function () {
                                                        loader.show();
                                                        modalContainerWarningAudioRecord.close();
                                                        let id = localStorage.getItem("selectID");
                                                        m.request({
                                                            method: 'DELETE',
                                                            url: '/api/task/' + m.route.param('taskId') + '/removeAudioComment',
                                                            data: id
                                                        }).then(function (response) {
                                                            var loc_audio = localStorage.getItem("AudioRecords");
                                                            loc_audio = JSON.parse(loc_audio);
                                                            let id = localStorage.getItem("selectID");
                                                            for(let i = 0; i < loc_audio.length; i++) {
                                                                if( loc_audio[i].fileID == id)
                                                                    loc_audio.splice(i, 1);
                                                            }
                                                            localStorage.setItem("AudioRecords", JSON.stringify(loc_audio));

                                                            let elem = document.getElementsByName(id);
                                                            if(elem)
                                                                document.getElementsByName(id)[0].remove();

                                                            loader.hide();
                                                        }, function () {
                                                            loader.hide();
                                                        });
                                                    };

                                                    let btn_no = document.createElement("button");
                                                    btn_no.classList.add('col-6', 'btn', 'btn-warning', 'btn-md');
                                                    btn_no.style = "margin-left: 10px;";
                                                    btn_no.innerText = "Нет";
                                                    btn_no.onclick = modalContainerWarningAudioRecord.close;
                                                    buttons.append(btn_yes);
                                                    buttons.append(btn_no);

                                                    modalContainerWarningAudioRecord
                                                        .open("Предупреждение",
                                                            "Вы действительно хотите удалить аудиосообщение?",
                                                            buttons);
                                                }
                                            }, [
                                                m("icon.fa.fa-trash")
                                            ])
                                        ])
                                    ])
                                ])
                            })
                        ]),
                    ])
                ]) : null,
            
            // Таблица операций
            currentList && currentList.length > 0 ? 
                m("table.table.table-bordered.table-condensed", [
                    m("thead", [
                        m("tr", [
                            m("th.text-center", "Операция"),
                            m("th.text-center", "Начало"),
                            m("th.text-center", "Окончание")
                        ])
                    ]),
                    m("tbody", [
                        currentList.map(function (operation, i) {
                            return [
                                m("tr", {
                                    class: operation.showDataInputs ? 'bg-grey' :
                                           operation.isOperationBlocked && operation.flightType === 'arrival' ? 'bg-blue' :
                                           operation.isOperationBlocked && operation.flightType === 'departure' ? 'bg-red' : ''
                                }, [
                                    m("td.col-xs-4",
                                        m("button.btn.btn-block", {
                                            onclick: function () {
                                                operation.showDataInputs = !operation.showDataInputs;
                                                flightSchedule.refresh(i);
                                                if (!operation.showDataInputs && operation.showCommentForm) {
                                                    operation.showCommentForm = false;
                                                }
                                            },
                                            class: 'block-' + operation.type,
                                            disabled: (currentTask && !currentTask.factBeginDateTime || operation.isCancelled) ? 'disabled' : false
                                        }, [
                                            m("span", operation.title + ' '),
                                            ((operation.comment && !operation.tmp_comment) || operation.operationValue ? m("span.glyphicon.glyphicon-star") : '')
                                        ]),
                                        (operation.isCancelled ? m("span.block-canceled") : ''),
                                        // Кнопка для значения операции
                                        (currentConfig.CanUpdateTGOValues  ?
                                                m("button.btn.btn-default.btn-block", {
                                                    onclick: function () {
                                                        operation.showOperationValueForm = true;
                                                        operation.showCommentForm = false;
                                                        operation.showCancelCommentForm = false;
                                                    },
                                                    class: (operation.showDataInputs ? '' : 'hidden')
                                                }, [
                                                    m("span", "Значение" + ' '),
                                                    (operation.operationValue != 0 ? m("span.glyphicon.glyphicon-star") : '')
                                                ]) : null
                                        ),
                                        // Кнопка комментария
                                        m("button.btn.btn-default.btn-block", {
                                            onclick: function () {
                                                operation.showCommentForm = true;
                                                operation.showCancelCommentForm = false;
                                                operation.showOperationValueForm = false;
                                            },
                                            class: (operation.showDataInputs ? '' : 'hidden')
                                        }, [
                                            m("span", "Комментарий" + ' '),
                                            (operation.comment && !operation.tmp_comment ? m("span.glyphicon.glyphicon-star") : '')
                                        ]),

                                        // Кнопка отмены
                                        (!operation.isAgentOperation
                                                ? m("button.btn.btn-danger.btn-block", {
                                                    onclick: function () {
                                                        operation.showCommentForm = true;
                                                        operation.showCancelCommentForm = true;
                                                        operation.showOperationValueForm = false;
                                                    },
                                                    class: operation.showDataInputs ? '' : 'hidden',
                                                    disabled: (operation.isOperationBlocked && operation.factBeginTime) ? 'disabled' : false
                                                }, "Отменить")
                                                : null
                                        ),
                                    ),
                                    // Ячейки времени
                                    operation.isMilestone ?
                                        m("td.text-center[colspan='2']",
                                            m("strong.text-info.big-text",
                                                {
                                                    style: currentConfig.bold_operation_times
                                                        ? 'font-size: 28px; font-weight: 700;'
                                                        : '',
                                                },
                                                operation.planBeginTime),
                                            m("br"),
                                            operation.factBeginTime ?
                                                m("strong.big-text", {
                                                    class: operation.isBeginWithDelay ? 'text-danger' : '',
                                                    style: currentConfig.font_size_in_services
                                                        ? 'overflow: hidden; font-size: ' + currentConfig.font_size_in_services + 'px'
                                                        : 'overflow: hidden;',
                                                }, operation.factBeginTime) :
                                                m("button.btn.btn-info.btn-block.btn-lg", {
                                                    class: operation.showDataInputs ? '' : 'hidden',
                                                    onclick: function () {
                                                        let listServiceLS = currentConfig["ListServiceLoadSheet"];
                                                        if(listServiceLS) {
                                                            let re = /\s*;\s*/;
                                                            listServiceLS = listServiceLS.split(re);
                                                            if(listServiceLS.indexOf(operation.id_serv.toString()) !== -1) {
                                                                flightSchedule.getStatusLoadsheet(i, 3);
                                                            }
                                                            else
                                                                flightSchedule.setOperationCommonTime(i);
                                                        }
                                                        else
                                                            flightSchedule.setOperationCommonTime(i);
                                                    }
                                                }, "Готово")
                                        ) : [
                                            m("td.text-center",
                                                m("strong.text-info.big-text",
                                                    {
                                                        style: currentConfig.bold_operation_times
                                                            ? 'font-size: 28px; font-weight: 700;'
                                                            : '',
                                                    },
                                                    operation.planBeginTime),
                                                m("br"),
                                                operation.factBeginTime ?
                                                    m("strong.big-text", {
                                                        class: operation.isBeginWithDelay ? 'text-danger' : '',
                                                        style: currentConfig.font_size_in_services
                                                            ? 'overflow: hidden; font-size: ' + currentConfig.font_size_in_services + 'px'
                                                            : 'overflow: hidden;',
                                                    }, operation.factBeginTime) :
                                                    m("button.btn.btn-info.btn-block.btn-lg", {
                                                        class: operation.showDataInputs ? '' : 'hidden',
                                                        onclick: function () {
                                                            let listServiceLS = currentConfig["ListServiceLoadSheet"];
                                                            if(listServiceLS) {
                                                                let re = /\s*;\s*/;
                                                                listServiceLS = listServiceLS.split(re);
                                                                if(listServiceLS.indexOf(operation.id_serv.toString()) !== -1) {
                                                                    flightSchedule.getStatusLoadsheet(i, 1);
                                                                }
                                                                else
                                                                    flightSchedule.setOperationStartTime(i);
                                                            }
                                                            else
                                                                flightSchedule.setOperationStartTime(i);
                                                        }
                                                    }, "Готово")
                                            ),
                                            m("td.text-center",
                                                m("strong.text-info.big-text",
                                                    {
                                                        style: currentConfig.bold_operation_times
                                                            ? 'font-size: 28px; font-weight: 700;'
                                                        : '',
                                                    },
                                                    operation.planFinishTime),
                                                m("br"),
                                                operation.factFinishTime ?
                                                    m("strong.big-text", {
                                                        class: operation.isFinishWithDelay ? 'text-danger' : '',
                                                        style: currentConfig.font_size_in_services
                                                            ? 'overflow: hidden; font-size: ' + currentConfig.font_size_in_services + 'px'
                                                        : 'overflow: hidden;',
                                                    }, operation.factFinishTime) :
                                                    m("button.btn.btn-info.btn-block.btn-lg", {
                                                        class: operation.showDataInputs ? '' : 'hidden',
                                                        onclick: function () {
                                                            let listServiceLS = currentConfig["ListServiceLoadSheet"];
                                                            if(listServiceLS) {
                                                                let re = /\s*;\s*/;
                                                                listServiceLS = listServiceLS.split(re);
                                                                if(listServiceLS.indexOf(operation.id_serv.toString()) !== -1) {
                                                                    flightSchedule.getStatusLoadsheet(i, 2);
                                                                }
                                                                else
                                                                    flightSchedule.setOperationEndTime(i);
                                                            }
                                                            else
                                                                flightSchedule.setOperationEndTime(i);
                                                        }
                                                    }, "Готово")
                                            )
                                        ],
                                    ModalWindowSignatureLS.init("ModalWindowSignatureLS")
                                ]),
                                // Форма для значения операции
                                (currentConfig.CanUpdateTGOValues ?
                                        m("tr", {
                                            class: operation.showOperationValueForm ? '' : 'hidden'
                                        }, [
                                            m("td[colspan='3']", [
                                                m("input.form-control", {
                                                    name: 'operationValue',
                                                    type:"number",
                                                    step:"1",
                                                    min:"0",
                                                    max:"100000",
                                                    placeholder: 'Введите значение по операции',
                                                    value : operation.operationValue,
                                                    onchange: function (e) {
                                                        if (e.target.value < 0) {
                                                            alert('Заначение должно быть больше нуля');
                                                            e.target.value = '';
                                                            operation.operationValue = '';
                                                            return false;
                                                        }
                                                        if (!Number.isInteger(Number(e.target.value))) {
                                                            alert('Заначение должно быть целым');
                                                            e.target.value = '';
                                                            operation.operationValue = '';
                                                            return false;
                                                        }
                                                        operation.operationValue = e.target.value;
                                                        operation.tmp_operationValue = e.target.value;
                                                    }
                                                } ),
                                                m("button.btn.btn-info.btn-block[type='text'][style='margin-top:3px']", {
                                                    class: operation.showOperationValueForm ? '' : 'hidden',
                                                    onclick: function () {
                                                        flightSchedule.saveOperationValue(i);
                                                    }
                                                },  "Сохранить")
                                            ])
                                        ]) : null
                                ),
                                // Форма для комментария
                                m("tr", {
                                    class: operation.showCommentForm ? '' : 'hidden'
                                }, [
                                    m("td[colspan='3']", [
                                        m("textarea.form-control", {
                                            rows: 2,
                                            name: 'comment',
                                            placeholder: 'Введите комментарий',
                                            onchange: function (e) {
                                                operation.comment = e.target.value;
                                                operation.tmp_comment = e.target.value;
                                            }
                                        }, operation.comment || ''),
                                        m("button.btn.btn-info.btn-block[type='text'][style='margin-top:3px']", {
                                            class: operation.showCancelCommentForm ? 'hidden' : '',
                                            onclick: function () {
                                                flightSchedule.saveOperationComment(i);
                                            }
                                        }, "Сохранить")
                                    ])
                                ]),
                                // Форма для отмены
                                m("tr", {
                                    class: operation.showCancelCommentForm ? '' : 'hidden'
                                }, [
                                    m("td[colspan='3']", [
                                        m("button.btn.btn-warning.btn-block[type='text'][style='margin-top:3px']", {
                                            onclick: function () {
                                                flightSchedule.saveOperationCancelComment(i);
                                                operation.showDataInputs = false;
                                            }
                                        }, "Подтвердить отмену")
                                    ])
                                ]),
                            ];
                        })
                    ])
                ]) : null,
            
            // Кнопка подписания
            currentTask ? m(".container[style='padding-bottom:20px']", [
                m("button.btn.btn-info.btn-lg[style='width:100%']", {
                    class: showSignatureButton ? '' : 'hidden',
                    onclick: function () {
                        ModalContainerTGO.open(currentTask);
                        var canvas = document.getElementById("canvasSignTGO");
                        if (canvas !== null) {
                                var signaturePad = new SignaturePad(canvas, {
                                backgroundColor: 'rgb(255, 255, 255)'
                            });
                        }
                        document.getElementById("save_sign_TGO").addEventListener("click", function () {
                            var canvas = document.getElementById("canvasSignTGO");
                            if(isCanvasBlank(canvas) == false)
                                saveTGOtoDB();

                            ModalContainerTGO.close();
                        });

                        document.getElementById('clear_sign').addEventListener('click', function () {
                            let canvas = document.getElementById("canvasSignTGO");
                            if (canvas !== null) {
                                    let signaturePad = new SignaturePad(canvas, {
                                        backgroundColor: 'rgb(255, 255, 255)'
                                    }
                                );
                                signaturePad.clear();
                            }
                        });
                    }
                }, [
                    "Подписать"
                ]),
                ModalContainerTGO.init(currentTask),
                m("button.btn.btn-default.btn-lg[style='width:100%; margin-top:3px']", {
                    onclick: function () {
                        m.route('/task/' + currentTask.taskId + '/accounting/tgo');
                    }
                }, "Лист учёта услуг"),
            ]) : null,

            // Комментарий снизу списка
            (currentTask && !currentConfig.work_comment_on_top) ?
                m("div[style='padding:7px 15px']", [
                    m("div[style='padding:7px 15px']", [
                        m("b", "Комментарий к работе"),
                        m("div", [
                            m("div[style='width: 100%;display: inline-flex;flex-direction: row;']", [
                                m("textarea.form-control.comment-" + currentTask.taskId, {
                                    rows: 2,
                                    name: 'comment',
                                    placeholder: 'Введите комментарий',
                                    onchange: function (e) {
                                        currentTask.comment = e.target.value;
                                    }
                                }, currentTask.comment || ''),
                                (currentTask && !currentTask.factFinishTime) ? m("button.btn", {
                                    onclick: function () {
                                        var permissionMic = false;
                                        if (!navigator.mediaDevices.enumerateDevices) {
                                            alert("enumerateDevices() not supported.");
                                        } else {
                                            navigator.mediaDevices
                                                .enumerateDevices()
                                                .then((devices) => {
                                                    for(let i = 0; i < devices.length; i++) {
                                                        if(devices[i].kind == "audioinput" && devices[i].deviceId != "") {
                                                            permissionMic = true;
                                                            break;
                                                        }
                                                    }
                                                    if(permissionMic) {
                                                        let timerId = localStorage.getItem("audioTimerId");
                                                        timerId !== 'underfined' ? timerId : 0;

                                                        if (!timerId) {
                                                            let event = new Event("startAudioRecord", {bubbles: false});
                                                            document.dispatchEvent(event);

                                                            let timerSec = 0;
                                                            let maxTime = currentConfig.LengthAudioRecord;
                                                            timerId = setInterval(function () {
                                                                timerSec++;
                                                                const minutes = Math.floor(timerSec / 60);
                                                                const seconds = timerSec - minutes * 60;
                                                                let formatted = [
                                                                    minutes.toString().padStart(2, '0'),
                                                                    seconds.toString().padStart(2, '0')
                                                                ].join(':');
                                                                document.getElementById("audioTimer").innerHTML = formatted;
                                                                if(timerSec == maxTime) {
                                                                    localStorage.setItem("lengthAudio", formatted);
                                                                    ModalContainerAudioRecord.close(true);
                                                                    let buttons = document.createElement("div");
                                                                    buttons.className = "col-12";
                                                                    let btn_ok = document.createElement("button");
                                                                    btn_ok.classList.add('btn', 'btn-warning', 'btn-md');
                                                                    btn_ok.innerText = "OK";
                                                                    btn_ok.onclick = modalContainerWarningAudioRecord.close;
                                                                    buttons.append(btn_ok);

                                                                    modalContainerWarningAudioRecord
                                                                        .open("Предупреждение",
                                                                        "Записан аудиокомментарий максимальной длительности",
                                                                            buttons);
                                                                }
                                                            }, 1000, timerSec, maxTime);
                                                            localStorage.setItem("audioTimerId", timerId);
                                                        }
                                                        ModalContainerAudioRecord.open();
                                                    }
                                                    else {
                                                        alert("Необходимо разрешить браузеру доступ к микрофону");
                                                    }
                                                })
                                                .catch((err) => {
                                                    alert(err.name + err.message);
                                                });
                                        }
                                    }
                                }, [
                                    m("div.record-button[id='mic_bg'][style='width:50px; height:50px']", [
                                        m("i.fa.fa-2x.fa-thin.fa-microphone[id='mic_icon']")
                                    ])
                                ]) : null,
                            ]),
                            m("button.btn.btn-info.btn-block[type='text'][style='margin-top:3px']", {
                                onclick: function () {
                                    flightSchedule.saveWorkComment();
                                }
                            }, "Сохранить комментарий")
                        ]),

                        m("div[id='audioRecords'][style='margin-top: 15px']",
                             currentAudioComment.map(function (im) {
                                return m("div[name='"+im.fileID+"'][style='margin-top:4px']", [
                                        m("audio[src=" + im.base64 + "]", {
                                            onended: function () {
                                                let button_play = this.parentNode.getElementsByTagName("button")[0];
                                                let i = button_play.getElementsByTagName("icon")[0];
                                                if (i.classList.contains("fa-pause")) {
                                                    this.pause();
                                                    i.classList.remove("fa-pause");
                                                    i.classList.add("fa-play");
                                                }
                                            }
                                        }),
                                        m("div.container[style='display: flex; justify-content: space-between;']", [
                                            m("div[style='display: flex; align-items: center;']", [im.fileName]),
                                            m("div", [
                                                m("button", {
                                                    onclick: function () {
                                                        let i = this.getElementsByTagName("icon")[0];
                                                        if (i.classList.contains("fa-play")) {
                                                            let audio = this.parentNode.parentNode.parentNode.getElementsByTagName("audio")[0];
                                                            audio.play();
                                                            i.classList.remove("fa-play");
                                                            i.classList.add("fa-pause");
                                                        } else if (i.classList.contains("fa-pause")) {
                                                            let audio = this.parentNode.parentNode.parentNode.getElementsByTagName("audio")[0];
                                                            audio.pause();
                                                            i.classList.remove("fa-pause");
                                                            i.classList.add("fa-play");
                                                        }
                                                    }
                                                }, [
                                                    m("icon.fa.fa-play")
                                                ]),

                                                // кнопка удалить аудиосообщение
                                                (currentTask && !currentTask.factFinishTime) 
                                                ? m("button[style='margin-left: 5px'][id='"+im.fileID+"']", {
                                                    onclick: function (el) {
                                                        localStorage.setItem("selectID", el.currentTarget.id);
                                                        let buttons = document.createElement("div");
                                                        let btn_yes = document.createElement("button");
                                                        btn_yes.classList.add('col-6', 'btn', 'btn-warning', 'btn-md');
                                                        btn_yes.innerText = "Да";
                                                        btn_yes.onclick = function () {
                                                            loader.show();
                                                            modalContainerWarningAudioRecord.close();
                                                            let id = localStorage.getItem("selectID");
                                                            m.request({
                                                                method: 'DELETE',
                                                                url: '/api/task/' + m.route.param('taskId') + '/removeAudioComment',
                                                                data: id
                                                            }).then(function (response) {
                                                                var loc_audio = localStorage.getItem("AudioRecords");
                                                                loc_audio = JSON.parse(loc_audio);
                                                                let id = localStorage.getItem("selectID");
                                                                for(let i = 0; i < loc_audio.length; i++) {
                                                                    if( loc_audio[i].fileID == id)
                                                                        loc_audio.splice(i, 1);
                                                                }
                                                                localStorage.setItem("AudioRecords", JSON.stringify(loc_audio));

                                                                let elem = document.getElementsByName(id);
                                                                if(elem)
                                                                    document.getElementsByName(id)[0].remove();

                                                                loader.hide();
                                                            }, function () {
                                                                loader.hide();
                                                            });
                                                        };

                                                        let btn_no = document.createElement("button");
                                                        btn_no.classList.add('col-6', 'btn', 'btn-warning', 'btn-md');
                                                        btn_no.style = "margin-left: 10px;";
                                                        btn_no.innerText = "Нет";
                                                        btn_no.onclick = modalContainerWarningAudioRecord.close;
                                                        buttons.append(btn_yes);
                                                        buttons.append(btn_no);

                                                        modalContainerWarningAudioRecord
                                                            .open("Предупреждение",
                                                                "Вы действительно хотите удалить аудиосообщение?",
                                                                buttons);
                                                    }
                                                }, [m("icon.fa.fa-trash")]) 
                                                : null
                                            ])
                                        ])
                                ])
                            })
                        ),
                    ])
                ]) : null,
            
            ModalContainerAudioRecord.init("modalAudioRecord"),
            modalContainerWarningAudioRecord.init("modalWarningAudioRecord"),
            
            m('hr'),
            
            // Кнопка завершения работы
            currentTask && currentTask.isConfirmed ? 
                m(".container[style='padding-bottom:20px']", [
                    m("button.btn.btn-danger.btn-block.btn-lg", {
                        disabled: !showEndWorkButton,
                        onclick: function () {
                            if(!DenyCloseWorks && CardSignature) {
                                flightSchedule.finishTask(currentConfig.taskFinishConfirm);
                            }
                            else if ((flightSchedule.isSigned === 0 && showSignatureButton)) {
                                alert('Перед завершением работы необходимо подписать технологическую карту.');
                            } else {
                                flightSchedule.finishTask(currentConfig.taskFinishConfirm);
                            }
                        }
                    }, "Закончить работу (" + currentTask.planFinishTime + ")")
                ]) : null,
        ];
    }
};
